import { render, staticRenderFns } from "./ProjectResource2.vue?vue&type=template&id=574cfc2f"
import script from "./ProjectResource2.vue?vue&type=script&lang=js"
export * from "./ProjectResource2.vue?vue&type=script&lang=js"
import style0 from "./ProjectResource2.vue?vue&type=style&index=0&id=574cfc2f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports